import { createTheme } from '@mui/material'
import { type TypographyVariantsOptions } from '@mui/material/styles'
import { type ThemeOptionVariant } from '@dhl-ui/theme'

// TODO: maybe export all definitions, or inject the fonts just like palette over our component creations
export const fontSizeBody1 = '1rem'
export const fontSizeBody2 = '0.875rem'
export const fontSizeCaption1 = '0.75rem'
const fontSizeCaption2 = '0.625rem'
const fontSizeH4 = '1.5rem'

// we can also directly consume this, see our `BaseTypography`!
export const typographyAll: TypographyVariantsOptions = {
  h1: {
    fontStyle: 'normal',
    fontWeight: 900,
    fontFamily: '"Delivery Condensed Black", Calibri, Arial, sans-serif',
    fontSize: '2.5rem',
    lineHeight: 1.2,
    letterSpacing: 0,
  },
  h2: {
    fontStyle: 'normal',
    fontWeight: 900,
    fontFamily: '"Delivery Condensed Black", Calibri, Arial, sans-serif',
    fontSize: '2rem',
    lineHeight: 1.2,
    letterSpacing: 0,
  },
  h3: {
    fontStyle: 'normal',
    fontWeight: 700,
    fontFamily: '"Delivery Condensed Black", Calibri, Arial, sans-serif',
    fontSize: '1.75rem',
    lineHeight: 1.2,
    letterSpacing: 0,
  },
  h4: {
    fontFamily: '"Delivery Condensed Black", Calibri, Arial, sans-serif',
    fontStyle: 'normal',
    fontSize: fontSizeH4,
    lineHeight: 1.2,
    fontWeight: 700,
    letterSpacing: 0,
  },
  h5: {
    fontFamily: '"Delivery Condensed Black", Calibri, Arial, sans-serif',
    fontStyle: 'normal',
    fontSize: '1.25rem',
    lineHeight: 1.2,
    fontWeight: 700,
    letterSpacing: 0,
  },
  h6: {
    fontFamily: '"Delivery Bold", Calibri, Arial, sans-serif',
    fontStyle: 'normal',
    fontSize: '1rem',
    fontWeight: 700,
    lineHeight: 1.2,
    letterSpacing: 0,
  },
  subtitle1: {
    fontFamily: '"Delivery Condensed Light", Calibri, Arial, sans-serif',
    fontStyle: 'normal',
    fontSize: '1.25rem',
    lineHeight: 1.4,
    fontWeight: 300,
    letterSpacing: 0,
  },
  subtitle2: {
    fontFamily: '"Delivery Condensed Light", Calibri, Arial, sans-serif',
    fontStyle: 'normal',
    fontSize: '1rem',
    lineHeight: 1.4,
    fontWeight: 300,
    letterSpacing: 0,
  },
  button: {
    fontFamily: '"Delivery Regular", Calibri, Arial, sans-serif',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: 1,
    letterSpacing: 0,
  },
  caption1: {
    fontFamily: '"Delivery Regular", Calibri, Arial, sans-serif',
    fontSize: fontSizeCaption1,
    fontWeight: 400,
    lineHeight: 1.25,
    letterSpacing: 0,
  },
  caption2: {
    fontFamily: '"Delivery Regular", Calibri, Arial, sans-serif',
    fontSize: fontSizeCaption2,
    fontWeight: 400,
    lineHeight: 1.2,
    letterSpacing: 0,
  },
  body1: {
    fontFamily: '"Delivery Regular", Calibri, Arial, sans-serif',
    fontSize: fontSizeBody1,
    fontWeight: 300,
    lineHeight: 1.375,
    letterSpacing: 0,
  },
  body2: {
    fontFamily: '"Delivery Regular", Calibri, Arial, sans-serif',
    fontSize: fontSizeBody2,
    fontWeight: 300,
    lineHeight: 1.425,
    letterSpacing: 0,
    WebkitFontSmoothing: 'antialiased',
  },
  fontFamily: '"Delivery Regular", Calibri, Arial, sans-serif',
}

export const typographyMobile: TypographyVariantsOptions = {
  ...typographyAll,
  h4: {
    ...typographyAll.h4,
    fontSize: '1.375rem',
  },
}

export const createTypography = (variant: ThemeOptionVariant) =>
  createTheme({
    typography: variant === 'mobile' ? typographyMobile : typographyAll,
  }).typography

/**
 * This part is for that we overrule the current setting by adding media query
 */
const typographyPatched = (variant: ThemeOptionVariant): TypographyVariantsOptions => {
  const collection = variant === 'mobile' ? typographyMobile : typographyAll

  return Object.fromEntries(
    Object.entries(collection).map(([key, value]) => [key, { ...value, '@media (min-width:600px)': undefined }])
  )
}

export const createTypographyPatched = (variant: ThemeOptionVariant) =>
  createTheme({
    typography: typographyPatched(variant),
  }).typography
